const uris = {};

function getUris(context) {
  const keys = context.keys();
  keys.forEach(k => k !== './index.js' && Object.assign(uris, context(k).default || context(k)));
}

getUris(require.context('./', false, /\.(js|ts)$/));

const mockF = url => url;

// let mockF = url => url;
// if (process.env.NODE_ENV === 'development') {
//   mockF = url => `/mock${url}`;
// }

export const mock = mockF;

export default uris;
